export const FOOTER_MESSAGE = 'Axis Bank Ltd. is acting as an AMFI Registered Mutual Fund Distributor.';
export const COPYRIGHT_MESSAGE = 'Copyright © 2021 Axis Bank';
export const DISCLAIMER = 'Disclaimer';
export const MUTUAL_FUNDS_DISCLAIMER = 'Mutual Funds Disclaimer';
export const PRIVACY_POLICY = 'Privacy Policy';
export const CODE_OF_COMMITMENT = 'Code of Commitment';
export const LINK_SEPARATOR = '|';
export const BETA_FOOTER_DISCLAIMER =
  "We're delighted to introduce to you the beta version of the new mutual funds module. In case you have any feedback to share, please reach out to your relationship manager. Always open to help you.";
